import { Record } from 'immutable'

export const Geolocation = Record({
  gdprApplicable: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/geolocation/models.js